// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1T-Tz","title":"styles_title__2FMLN"};